import store from '../store/store';

export default function filterMiddleware(to) {
  store.dispatch('FILTERS/setRoute', to).then();
}
